<template>
	<div>
        <div :class="getStatusHeader.header.minimaze ? 'chat__room-wrap' : 'chat__room-wrap chat__room-wrap_headMinimaze'">
            <scrollbar class="roomsWrap">
                <div class="chat__room-title" @click="rooms">{{activaTeam}} IQQUANTUM</div>
                <div v-if="activePrivateRoom !== null && activePrivateRoom !== 'directRoom'">
                    <nav-item  v-for="(room, index) in activePrivateRoom" class="chat__room-item-main" :key="index + 'pr'"
                        :roomId="room.id" :avatarRoom="room.avatar" :roomTitle="room.title" :typeRoom="'private'"
                        :subtitle="room.subtitle" :mail="room.mail" :tel="room.tel">
                    </nav-item>
                </div>
                <div v-if="activeRooms !== null" class="chat__room-title">ЧАТ КОМНАТЫ</div>
                <div v-if="activeRooms !== null">
                    <nav-item  v-for="(room, index) in activeRooms" class="chat__room-item-main" :key="index" 
                        :roomId="room.id" :avatarRoom="room.avatar" :roomTitle="room.title" :typeRoom="'public'">
                    </nav-item>
                </div>
                <div v-if="activePrivateRoom === null" class="chat__room-infMsg">
                    По вопросам партнерства и сотрудничества Вы можете обратиться к нашим консультантам или отправить запрос на <a href="mailto:info@iqquantum.com">info@iqquantum.com</a>
                </div>
                <div v-if="activePrivateRoom === 'directRoom'">
                    <nav-itemDirect v-for="(item,index) in getDirectRooms" :key="index" :roomInfo="item" :count="index">
                    </nav-itemDirect>
                </div>
            </scrollbar>
        </div>
		<!--<template v-if="chatPrivateRooms.length">
			<h4>{{$t('chat.privateRooms')}}</h4>
			<div v-for="room in chatPrivateRooms"
				:class="['room-title', (room.default ? 'room-title-default' : '')]">
				{{ room.name }}
			</div>
		</template>

		<template v-if="chatDirectRooms.length">
			<h4>{{$t('chat.directRooms')}}</h4>
			<div v-for="room in chatDirectRooms"
				:class="['room-title', (room.default ? 'room-title-default' : '')]">
				{{ room.name }}
			</div>
		</template>

		<br/>
		<a href="#" @click="$store.dispatch('chat/listChannels')">
			query channels
		</a>-->
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import ChatLogin from './chat-login.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { setTimeout } from 'timers';
import { appStartTime } from '../../model/app-start-time.js';
import NavigatorItem from './chat-navigatorItem';
import NavigatorItemDirect from './chat-navigatorItemDirect'
import ChatMessage from './chat-vertical-widget-messages';
export default {
	components: {
        'chat-login': ChatLogin,
        "scrollbar":VuePerfectScrollbar,
        "nav-item":NavigatorItem,
        "nav-itemDirect":NavigatorItemDirect,
        "chat-messages": ChatMessage,
    },
	props: {
        activaTeam: {
            default:'Команда'
        },
        activeRooms:{
            default:()=> {
                return [
                    {
                        title:'Общая',
                        id:'GENERAL',
                        avatar:require('../../assets/img/common_room.png'),
                    },
                    {
                        title:'EUR/USD',
                        id:'GxPdourxnLZTn8bS3',
                        avatar: require('../../assets/img/EUR-USD.png')
                    },
                    {
                        title:'GBP/USD',
                        id:'SzTxmGjZ3Ls7meHip',
                        avatar: require('../../assets/img/GBP-USD.png')
                    },
                    {
                        title:'USD/JPY',
                        id:'quNyJDfKMLbtD2Cpd',
                        avatar: require('../../assets/img/JPY-USD.png')
                    },
                    {
                        title:'EUR/GBP',
                        id:'qnyBnbnoXAphn9Tyq',
                        avatar: require('../../assets/img/GBP-USD.png')
                    },
                    {
                        title:'USD/CAD',
                        id:'oYDdSLr8Ko4cjkAqR',
                        avatar: require('../../assets/img/USD-CAD.png')
                    },
                    {
                        title:'AUD/USD',
                        id:'rxJCXtWfTWM2DxSWD',
                        avatar: require('../../assets/img/AUD-USD.png')
                    },
                    {
                        title:'NZD/USD',
                        id:'FyHkn552jTt392MjM',
                        avatar: require('../../assets/img/NZD-USD.png')
                    },
                    {
                        title:'USD/CHF',
                        id:'GgaShiX8ebRZxT5j4',
                        avatar: require('../../assets/img/USD-CHF.png')
                    },
                ]
            }
        },
        activePrivateRoom: {
            default: ()=> {
                return[
                    {
                        title:'Алексей Денисов',
                        subtitle:'Управляющий трейдер',
                        id:'aldenisov',
                        avatar:require('../../assets/img/adenisov.png'),
                    },
                    {
                        title:'СЛУЖБА КОМПЛАЕНС',
                        subtitle:'',
                        id:'vd_iqquantum_com',
                        avatar: require('../../assets/img/manager.png')
                    }, 
                ]
            }
        }
    },
	data() {
		return {
            
		};
	},
	computed: {
		...mapGetters({
                getStatusHeader:'usersets/getSettings',
                getUserRooms:'chat/userRooms'
               }),
        getDirectRooms() {
            if(!this.getUserRooms)
                return
            let dRooms = sortDirectRoom(this.getUserRooms)
            return dRooms;
        }
	},
	methods: {
        rooms() {
            this.$store.dispatch('chat/queryRooms');
        }
    },
    mounted() {
        setTimeout(()=>{
            let room = 'GENERAL'
            this.$store.dispatch('chat/enterRoom', room);
        },2000)
        
    }
    
};
function sortDirectRoom (data) {
    let directRoom = []
    for(let i = 0; i < data.length; i++) {
        if(data[i].t === 'd')
            directRoom.push(data[i])
    }
    return directRoom
}
</script>

<style scoped lang="less">
    .roomsWrap {
        height: 100%;
        overflow: auto;
    }
    .chat__room {
        &-infMsg {
            width: 360px;
            text-align: center;
            font-family: Arimo;
            padding: 0px 12px 0 12px;
            box-sizing: border-box;
            line-height: 1.5;
            color:#adc7e1;
            a {
                color: #00ffd0;
            }
        }
        &-wrap {
            height:calc(100vh - 98px);
            &_headMinimaze {
                 height:calc(100vh - 54px);
            }
        }
        &-title {
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 3.64;
            letter-spacing: 0.4px;
            color: #adc7e1;
            text-transform: uppercase;
            padding-left: 12px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
</style>